// removed by extract-text-webpack-plugin
module.exports = {"text_images":"text_images__1zX9D","text_images_media_image":"text_images_media_image__2hw-X","text_info":"text_info__2eLPx","text_info_title":"text_info_title__1aoxa","text_info_section":"text_info_section__2Y2UF","text_info_section_title":"text_info_section_title__bCmcz","text_info_close":"text_info_close__68bfH","text_info__sideMenuPage":"text_info__sideMenuPage__1Lsos","text_info__contact":"text_info__contact__1MYjb"};


//////////////////
// WEBPACK FOOTER
// ./components/Text/Text.scss
// module id = r7jR
// module chunks = 0